


import React, { useEffect, useState } from 'react'
import NormalTable from '../../../../Component/NormalTable'
import { Box, Button, Grid, Typography } from '@mui/material';
import { PictureAsPdf } from '@mui/icons-material';
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { masterAPI } from '../../../Masters/dataConfig';
import { axiosPrivate } from '../../../../axios/axios';
import { color } from '../../../../StyleData/Config';

const TransationHistory = ({info}) => {
    const [data,setData]=useState([])
    const[reciptData, setReciptData] = useState([])
    const [transferData, setTransferData] = useState([])

    useEffect(()=>{
        getData()
    },[])

    const getData=async()=>{
      const link = masterAPI["issueReturn"].getTransactionHistory;
     await axiosPrivate
        .get(`${link}/${info.partId}`)
        .then((res) => {
          console.log(res.data, "issueRetun Data");
        
          setData(res.data.result);
        })
        .catch((e) => {
          console.log(e, "allinven");
         
          setData([])
        });
          const linkrec = masterAPI["receipt"].getbyreceiptitemlistbypartid;
        await axiosPrivate
        .get(`${linkrec}/${info.partId}`)
        .then((res) => {
          console.log(res.data, "recipt Data");
        
          setReciptData(res.data.result);
        })
        .catch((e) => {
          console.log(e, "allinven");

          setReciptData([])
        });
          const linkTransfer = masterAPI["partmovement"].getTransferTransactionHistroy;
        await axiosPrivate
        .get(`${linkTransfer}/${info.partId}`)
        .then((res) => {
          console.log(res.data, "transfer Data");

          setTransferData(res.data.result);
        })
        .catch((e) => {
          console.log(e, "allinven");

          setTransferData([])
        });
      }

    // Show "code - name" when both exist, otherwise "---"
    const formatCodeName = (code, name) =>
      (!code && !name) ? "---" : `${code} - ${name}`;

    const codeNameCell = (codeKey, nameKey) => ({ cell }) => (
      <Typography sx={{ fontSize: "inherit", fontWeight: "inherit", color: "inherit" }}>
        {formatCodeName(cell.row.original[codeKey], cell.row.original[nameKey])}
      </Typography>
    );

    const columns = [
       {
        Header:"Stock Room",
        accessor:"stockRoomName",
        Cell: codeNameCell("stockRoomCode", "stockRoomName"),
       },
        {
            Header: "Aisle",
            accessor: "aisleName",
            Cell: codeNameCell("aisleCode", "aisleName"),
          },
          {
            Header: "Row",
            accessor: "rowName",
            Cell: codeNameCell("rowCode", "rowName"),
          },
          {
            Header: "Bin",
            accessor: "binName",
            Cell: codeNameCell("binCode", "binName"),
          },
          {
            Header:"Type",
            accessor:"transactionType"
          },

          {
            Header: "Quantity",
            accessor: "quantity",
          },

      ];
const columnsRecipt = [
       {
        Header:"Stock Room",
        accessor:"stockRoomName",
        Cell: codeNameCell("stockRoomCode", "stockRoomName"),
       },
        {
            Header: "Aisle",
            accessor: "aisleName",
            Cell: codeNameCell("aisleCode", "aisleName"),
          },
          {
            Header: "Row",
            accessor: "rowName",
            Cell: codeNameCell("rowCode", "rowName"),
          },
          {
            Header: "Bin",
            accessor: "binName",
            Cell: codeNameCell("binCode", "binName"),
          },

          {
            Header: "Received Quantity",
            accessor: "receivedQuantity",//inventoryQuantity
          },
               {
            Header: "Inventory Quantity",
            accessor: "inventoryQuantity",//inventoryQuantity
          },
           {
            Header: "Unit Price",
            accessor: "unitPrice",
          },


      ];
const columnsTransfer = [
       {
        Header: "From Stock Room",
        accessor: "fromStockRoomName",
        Cell: codeNameCell("fromStockRoomCode", "fromStockRoomName"),
       },
       {
        Header: "From Aisle",
        accessor: "fromAisleName",
        Cell: codeNameCell("fromAisleCode", "fromAisleName"),
       },
       {
        Header: "From Row",
        accessor: "fromRowName",
        Cell: codeNameCell("fromRowCode", "fromRowName"),
       },
       {
        Header: "From Bin",
        accessor: "fromBinName",
        Cell: codeNameCell("fromBinCode", "fromBinName"),
       },
       {
        Header: "To Stock Room",
        accessor: "toStockRoomName",
        Cell: codeNameCell("toStockRoomCode", "toStockRoomName"),
       },
       {
        Header: "To Aisle",
        accessor: "toAisleName",
        Cell: codeNameCell("toAisleCode", "toAisleName"),
       },
       {
        Header: "To Row",
        accessor: "toRowName",
        Cell: codeNameCell("toRowCode", "toRowName"),
       },
       {
        Header: "To Bin",
        accessor: "toBinName",
        Cell: codeNameCell("toBinCode", "toBinName"),
       },
       {
        Header: "Quantity",
        accessor: "quantity",
       },
      ];
    const buildTableRows = (rows, cols) =>
      rows.map((row, index) => [
        (index + 1).toString(),
        ...cols.map((col) => {
          const value = row[col.accessor];
          if (value === null || value === undefined) return "";
          if (typeof value === "object") return JSON.stringify(value);
          return String(value);
        }),
      ]);

    const handleDownloadPdf = () => {
      const doc = new jsPDF({ orientation: "landscape", unit: "mm" });
      const sections = [
        { title: "Issue Return Transaction History", rows: data, cols: columns },
        { title: "Receipt Items Transaction History", rows: reciptData, cols: columnsRecipt },
        { title: "Transfer Transaction History", rows: transferData, cols: columnsTransfer },
      ];

      let startY = 12;

      sections.forEach(({ title, rows, cols }) => {
        doc.setFontSize(12);
        doc.text(title, 10, startY);

        autoTable(doc, {
          head: [["No", ...cols.map((col) => col.Header)]],
          body: buildTableRows(rows, cols),
          startY: startY + 4,
          theme: "grid",
          styles: {
            fontSize: 8,
            cellPadding: 1.5,
            font: "helvetica",
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          headStyles: {
            fontStyle: "normal",
            textColor: [0, 0, 0],
            fillColor: false,
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          columnStyles: { 0: { cellWidth: 8, halign: "center" } },
        });

        startY = doc.lastAutoTable.finalY + 8;
      });

      doc.save(`${info.partName || "Part"} transaction history.pdf`);
    };

  return (
    <Grid>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: "0.5rem" }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<PictureAsPdf />}
          onClick={handleDownloadPdf}
        >
          Download PDF
        </Button>
      </Box>
   <Typography
              sx={{
                // color: color.masterDialogTitleColor,
                // fontSize: color.masterDialogFontSize,
                fontSize: color.AssetTitlesize,
                fontWeight: color.sideFontWeightAsset,
              }}
            >Issue Return Transaction History</Typography>
     <NormalTable data={data} columns={columns} />
        <Typography
              sx={{
                // color: color.masterDialogTitleColor,
                // fontSize: color.masterDialogFontSize,
                fontSize: color.AssetTitlesize,
                fontWeight: color.sideFontWeightAsset,
              }}
            >Receipt Items Transaction History</Typography>
     <NormalTable data={reciptData} columns={columnsRecipt} />
        <Typography
              sx={{
                fontSize: color.AssetTitlesize,
                fontWeight: color.sideFontWeightAsset,
              }}
            >Transfer Transaction History</Typography>
     <NormalTable data={transferData} columns={columnsTransfer} />
     </Grid>
  )
}

export default TransationHistory